// Единая регистрация модулей chart.js (по образцу MainJornal.jsx проекта).
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { SankeyController, Flow } from "chartjs-chart-sankey";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Title,
  Tooltip,
  Legend,
  SankeyController,
  Flow
);

// Общий стиль
ChartJS.defaults.color = "#8b98a9";
ChartJS.defaults.borderColor = "#2a3444";
ChartJS.defaults.font.family =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const PALETTE = ["#4f7cff", "#3fb950", "#d29922", "#a371f7", "#f85149", "#39c5cf"];
